// import { useNavigate } from "react-router-dom";
import apedBetaLogo from "../assets/aped_logo_text.svg";

const TradeView = () => {
  // const navigate = useNavigate();

  // const handleLaunchClick = () => {
  //   navigate("/alpha");
  // };

  const features = [
    {
      title: "Advanced Aggregation",
      description:
        "Access the best prices across multiple HyperLiquid venues with intelligent order routing",
      icon: "⚡",
    },
    {
      title: "Lightning Fast",
      description:
        "Execute trades in milliseconds with HyperLiquid's native speed and efficiency",
      icon: "🚀",
    },
    {
      title: "Deep Liquidity",
      description:
        "Tap into HyperLiquid's deep liquidity pools for optimal trade execution",
      icon: "💧",
    },
  ];

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-black" />

      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-600/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/5 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-radial from-purple-600/5 to-transparent rounded-full blur-2xl" />
      </div>

      {/* Header */}
      <header className="relative z-10 flex justify-between items-center p-6 md:p-8">
        <div className="flex items-center space-x-3">
          <img
            className="w-8 h-8 md:w-10 md:h-10"
            src={apedBetaLogo}
            alt="APED"
          />
        </div>
        <nav className="hidden md:flex space-x-8">
          {/* <a
            href="#features"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Features
          </a>
          <a
            href="#about"
            className="text-gray-300 hover:text-white transition-colors"
          >
            About
          </a>
          <a
            href="#docs"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Docs
          </a> */}
        </nav>
      </header>

      {/* Main Content */}
      <main className="relative z-10 flex flex-col items-center justify-center min-h-[calc(100vh-120px)] px-6 text-center">
        {/* Hero Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
            <span className="bg-gradient-to-r from-white via-purple-200 to-purple-400 bg-clip-text text-transparent">
              APED
            </span>
          </h1>

          <h2 className="text-xl md:text-3xl lg:text-4xl text-gray-300 mb-4 font-light">
            Perpetual Aggregator on
          </h2>

          <div className="flex items-center justify-center space-x-3 mb-8">
            <span className="text-2xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">
              HyperLiquid
            </span>
            <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" />
          </div>

          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-12 leading-relaxed">
            Experience the next generation of perpetual trading with advanced
            aggregation, lightning-fast execution, and deep liquidity on
            HyperLiquid's cutting-edge infrastructure.
          </p>

          {/* CTA Button */}
          <button
            disabled
            className="group relative inline-flex items-center justify-center px-8 py-4 md:px-12 md:py-6 text-lg md:text-xl font-bold text-gray-500 bg-gradient-to-r from-gray-600 to-gray-700 rounded-2xl cursor-not-allowed opacity-50"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-700 rounded-2xl blur opacity-75" />
            <span className="relative flex items-center space-x-3">
              <span>LAUNCH ALPHA</span>
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </span>
          </button>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl hover:border-purple-500/50 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-400 mb-2">
              24/7
            </div>
            <div className="text-gray-400">Trading</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-400 mb-2">
              &lt;1ms
            </div>
            <div className="text-gray-400">Latency</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-400 mb-2">
              ∞
            </div>
            <div className="text-gray-400">Liquidity</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-purple-400 mb-2">
              0%
            </div>
            <div className="text-gray-400">Slippage*</div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 text-center py-8 text-gray-500 text-sm">
        <p>*Optimal conditions. Built on HyperLiquid infrastructure.</p>
      </footer>
    </div>
  );
};

export default TradeView;
